import { InformationCircleIcon } from '@heroicons/react/20/solid'
import { PropsWithChildren, ReactNode } from 'react';
import { classNamesOrEmpty } from '../../style/common';

type WarningAlertType = "default" | "transparent-white";
type WarningAlertElements = "container" | "text" | "link";
export type WarningAlertStyles = Record<WarningAlertType, Record<WarningAlertElements, string>>;

export type InfoAlertProps = {
    header?: ReactNode | undefined,
    link?: string,
    type?: WarningAlertType,
    linkText?: string,
    classNames?: {
        container?: string | undefined
    }
} & PropsWithChildren;

const styleDictionary: WarningAlertStyles = {
    "transparent-white": {
        container: "bg-none",
        text: "text-white",
        link: "text-white hover:text-gray-200"
    },
    default: {
        container: "bg-info border border-info-secondary/25",
        text: "text-info-contrast",
        link: "text-info-contrast hover:text-info-contrast/75"
    }
}

export function InfoAlert(props: InfoAlertProps) {
    const styleType = props.type ?? "default";
    const styles = styleDictionary[styleType];

    return (
        <div className={`rounded-md p-4 overflow-y-auto overflow-x-hidden ${styles.container} ${classNamesOrEmpty(props.classNames?.container)}`}>
            <div className="flex">
                <div className="flex-shrink-0">
                    <InformationCircleIcon className="h-5 w-5 text-blue-400 mt-[2px]" aria-hidden="true" />
                </div>
                <div className="ml-3 flex-1 md:flex md:justify-between flex flex-col overflow-hidden">
                    <div style={{ wordBreak: "break-word" }} className={`whitespace-break-spaces ${styles.text}`}>{props.header}</div>
                    <div className="text-sm text-info-contrast">
                        {
                            props.children
                        }
                    </div>
                    {
                        props.link &&
                        <p className="mt-4 text-sm">
                            <a href={props.link} target="_blank" className="whitespace-nowrap font-medium text-info-contrast hover:text-info-contrast/75">
                                {props.linkText}
                                <span aria-hidden="true"> &rarr;</span>
                            </a>
                        </p>
                    }
                </div>
            </div>
        </div>
    )
}
